import { render, staticRenderFns } from "./pay-button.vue?vue&type=template&id=685ce20e"
import script from "./pay-button.vue?vue&type=script&lang=js"
export * from "./pay-button.vue?vue&type=script&lang=js"
import style0 from "./pay-button.vue?vue&type=style&index=0&id=685ce20e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports